import { render, staticRenderFns } from "./AdminSettingsItem.vue?vue&type=template&id=8eee31fa&lang=pug&"
import script from "./AdminSettingsItem.vue?vue&type=script&lang=js&"
export * from "./AdminSettingsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports